<template>
  <div class="page-wrapper">   
    <div class="page-title">
      <CIcon name="cil-location-pin" /> Area / Beat Information
    </div>
    <CRow v-if="states.length < 0">
        <CCol md="12" class="text-center" v-if="httpError == ''">
            <strong>Loading...Please wait!</strong>
            <CProgress
                :value="100"
                color="primary"
                striped
                animated
                class="mb-2"
            />
        </CCol>
        <CCol md="12" class="text-center" v-else>
            <strong><CIcon name="cil-ban"/> {{httpError}}</strong>
        </CCol>
    </CRow>     
    <CRow v-else>
        <CCol md="6" class="pad-r-0">
            <CCard>
                <CCardHeader>
                    <strong>Beat Information</strong>                    
                </CCardHeader>
                <CCardBody class="text-center">
                    <div style="height: 60vh; width: 100%" >                      

                        <CInput 
                            placeholder="Enter FID"
                            label=""
                            v-model="fid"
                        >
                            <template #prepend>
                                <CButton color="primary" @click="getOneArea()">
                                <CIcon name="cil-magnifying-glass"/> Search
                                </CButton>
                            </template>
                        </CInput>
                        <pulse-loader :loading="loading" color="#2E7D32" ></pulse-loader>
                        <div v-if="loading == false">

                            FID : {{area.fid}}<br>
                            CIRLCE : {{area.circle}}<br>
                            DIVISION : {{area.division}}<br>
                            RANGE : {{area.range}}<br>
                            BLOCK : {{area.block}}<br>
                            BEAT : {{area.beat}}

                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
        <CCol md="6" class="pad-r-0">
            <CCard>
                <CCardHeader>
                    <strong>Beat Map</strong>
                </CCardHeader>
                <CCardBody class="text-center">
                    <div style="height: 60vh; width: 100%" >
                        <l-map
                            ref="mapControl"
                            v-if="!loading"
                            :zoom="zoom"
                            :center="center"
                            :bounds="bounds"
                            :options="mapOptions"
                            
                            @update:bounds="boundsUpdated"
                        >
                            <l-tile-layer
                                :url="url"
                                :attribution="attribution"
                            />

                            <l-polygon :lat-lngs="polygon.latlngs" :color="polygon.color" v-if="polygon.latlngs != null"></l-polygon>

                            <l-geo-json
                                :geojson="geojson"
                            />
                            <l-control
                                :position="'bottomleft'"
                                class="custom-control-watermark"
                            >

                                Map generated on JungleWatch
                            </l-control>
                        </l-map>

                        <pulse-loader :loading="loading" color="#2E7D32" ></pulse-loader>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
        
        <!-- <CCol md="2">                
            <CCard>
                <CCardHeader class="text-center">
                    <strong v-if="!loading">Divisions</strong>
                    
                    <CInput 
                        placeholder="Start typing caseid to serarch.."
                        label="Data"
                        v-model="searchText"
                    >
                        <template #prepend>
                            <CButton color="primary" @click="apply()">
                            <CIcon name="cil-magnifying-glass"/> Search
                            </CButton>
                        </template>
                    </CInput>
                    <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
                </CCardHeader>
                <CCardBody>
                    <b-table 
                        hover
                        selectable
                        select-mode="single"
                        @row-selected="onSelectRow"
                        :items="divisions"
                        :fields="fields.divisions"
                        style="cursor : pointer"
                        id="divisionTable"
                        thead-class="d-none" 
                    >
                    </b-table>
                    
                </CCardBody>
                <CCardFooter class="text-center">
                    <CButton type="submit" size="sm" color="info"  @click="showDivisionModal(true)"><CIcon name="cil-plus"/> Add Division</CButton>
                </CCardFooter>
            </CCard>
        </CCol> 
        <CCol md="2">                
            <CCard>
                <CCardHeader class="text-center">
                    <strong v-if="!loading">Ranges</strong>
                    <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
                </CCardHeader>
                <CCardBody>
                    <b-table 
                        hover
                        selectable
                        select-mode="single"
                        @row-selected="onSelectRow"
                        :items="ranges"
                        :fields="fields.ranges"
                        style="cursor : pointer"
                        id="rangeTable"
                        thead-class="d-none" 
                    >
                    </b-table>
                    
                </CCardBody>
                <CCardFooter class="text-center">
                    <CButton type="submit" size="sm" color="info" v-if="selectedDivision!=null" @click="showRangeModal(true)"><CIcon name="cil-plus"/> Add Range</CButton>
                </CCardFooter>
            </CCard>
        </CCol>         -->
    </CRow>   


    <CModal
      title="Add a new state"
      size="lg"
      :show.sync="modals.addState"
    >
        <CForm>
            <CInput
                description="Name of state"
                label="Name"
                horizontal
                v-model="addArea.name"
            />     
            <CInput
                description="Please do not change this"
                label="Type"
                horizontal
                disabled
                v-model="addArea.type"
            />   
            <CTextarea
                description="Paste the coordinates here in following format [ [long, lat], [long, lat].... ]"
                label="Polygon"
                placeholder="Add a coordinates"
                horizontal
                rows="9"
                v-model="addArea.polygon"
            />   
        </CForm>
        <template v-slot:footer>
            <CButton type="submit" size="sm" color="danger" style="float : left" @click="showStateModal(false)">Cancel</CButton>
            <CButton type="submit" size="sm" color="success" style="float : right" @click="submitArea()">Submit</CButton>
                        
        </template>
    </CModal>

    <CModal
        
        title="Add a new division"
        size="lg"
        :show.sync="modals.addDivision"
    >
        <CForm>
            <CInput
                description="Name of division"
                label="Name"
                horizontal
                v-model="addArea.name"
            />     
            <CInput
                description="Please do not change this"
                label="Type"
                horizontal
                disabled
                v-model="addArea.type"
            />   
            <CTextarea
                description="Paste the coordinates here in following format [ [long, lat], [long, lat].... ]"
                label="Polygon"
                placeholder="Add a coordinates"
                horizontal
                rows="9"
                v-model="addArea.polygon"
            />   
        </CForm>
        <template v-slot:footer>
            <CButton type="submit" size="sm" color="danger" style="float : left" @click="showDivisionModal(false)">Cancel</CButton>
            <CButton type="submit" size="sm" color="success" style="float : right" @click="submitArea()">Submit</CButton>
                        
        </template>
    </CModal>

    <CModal
        v-if="selectedDivision != null"
        title="Add a new range"
        size="lg"
        :show.sync="modals.addRange"
    >
        <CForm>
            <CInput
                description="Name of range"
                label="Name"
                horizontal
                v-model="addArea.name"
            />     
            <CInput
                description="Please do not change this"
                label="Type"
                horizontal
                disabled
                v-model="addArea.type"
            />   
            <CInput
                description="State"
                label="State"
                horizontal
                disabled
                v-model="selectedDivision.name"
            />   
            <CTextarea
                description="Paste the coordinates here in following format [ [long, lat], [long, lat].... ]"
                label="Polygon"
                placeholder="Add a coordinates"
                horizontal
                rows="9"
                v-model="addArea.polygon"
            />   
        </CForm>
        <template v-slot:footer>
            <CButton type="submit" size="sm" color="danger" style="float : left" @click="showRangeModal(false)">Cancel</CButton>
            <CButton type="submit" size="sm" color="success" style="float : right" @click="submitArea()">Submit</CButton>
                        
        </template>
    </CModal>

    
  </div>
</template>

<script>
import axios from 'axios';
import store from '../store';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import GridLoader from 'vue-spinner/src/GridLoader.vue'
import { CRS, latLng, featureGroup } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LControl, LPolygon, LGeoJson } from "vue2-leaflet";
import { Icon } from 'leaflet';
export default {
  name: 'Area',
  components: {
        LMap,
        LPolygon,
        LTileLayer,
        LMarker,
        LPopup,
        LTooltip,
        LControl,
        LGeoJson,
        Icon,
        PulseLoader,
        GridLoader
  },
  data () {
    return {
        id : '',
        baseURL : store.state.baseURL,
        selected: [], // Must be an array reference!
        show: true,
        horizontal: { label:'col-3', input:'col-9' },
        options: ['Option 1', 'Option 2', 'Option 3'],
        states : [],
        divisions : [],
        ranges : [],
        httpError : '',
        largeModal : false,
        noimage : '/img/noimage.png',        
        searchText : '',
        perPage: 12,
        currentPage: 1,
        tableLength : 0,
        loading : true,
        fields : {
            states : [
                {
                    key : 'name',
                    label : ''
                }
            ],
            divisions : [
                {
                    key : 'name',
                    label : ''
                }
            ],
            ranges : [
                {
                    key : 'name',
                    label : ''
                }
            ],
            area : [
                {
                    key : 'properties.description.FID',
                    label : 'FID'
                },
                {
                    key : 'properties.description.CIRCLE',
                    label : 'CIRLCE'
                },
                {
                    key : 'properties.description.DIVISION',
                    label : 'DIVISION'
                },
                {
                    key : 'properties.description.RANGE',
                    label : 'RANGE'
                },
                {
                    key : 'properties.description.BLOCK',
                    label : 'BLOCK'
                },
                {
                    key : 'properties.description.BEAT',
                    label : 'BEAT'
                }
            ]
        },
        areaData : [],
        selectedState : null,
        selectedDivision : null,
        selectedRange : null,

        zoom: 4,
        bounds: null,            
        center: latLng(20.5937, 78.9629),
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        mapCRS: CRS.EPSG3857,
        attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        mapOptions: {
            zoomSnap: 0.5
        },
        showMap: true,
        polygon: {
            latlngs: null,
            color: 'red'
        },
        addArea : {
            name : null,
            type : null,
            polygon : null,
            hierarchyTop : null
        },

        area : {
            fid : '',
            circle : '',
            division : '',
            range : '',
            block : '',
            beat : '',
        },

        modals : {
            addState : false,
            addDivision : false,
            addRange : false
        },

        fid : '1'

        
    }
  },
  created() {
    //   this.getArea('division', null);
    this.getOneArea();
  },
  methods: {
    showStateModal(d){
        this.addArea = {
            name : null,
            type : null,
            polygon : null,
            hierarchyTop : null
        }
        if(d){
            this.addArea.type = "State"
        }

        this.modals.addState = d;
    },
    showRangeModal(d){
        this.addArea = {
            name : null,
            type : null,
            polygon : null,
            hierarchyTop : null
        }
        if(d){
            this.addArea.type = "Forest Range"
            this.addArea.hierarchyTop = this.selectedDivision._id
        }

        this.modals.addRange = d;
    },
    showDivisionModal(d){
        this.addArea = {
            name : null,
            type : null,
            polygon : null,
            hierarchyTop : null
        }
        if(d){
            this.addArea.type = "Forest Division"
        }

        this.modals.addDivision = d;
    },
    getLatLng(lat, lng){
        return latLng(lat, lng);
    },
    zoomUpdate(zoom) {
        this.currentZoom = zoom;
    },
    centerUpdate(center) {
        this.currentCenter = center;
    },
    boundsUpdated (bounds) {
      this.bounds = bounds;
    },
    onSelectRow(row){
        const data_item = row[0];

        try{
            
            if(data_item.type == "State")
            {
                this.getArea('division', data_item._id)
                this.selectedState = data_item;
                this.selectedDivision = null;
                this.selectedRange = null;

            }
            else if(data_item.type == "Forest Division"){
                this.getArea('range', data_item._id)
                this.selectedDivision = data_item;
                this.selectedRange = null;
            }
            else if(data_item.type == "Forest Range"){
                this.getArea('beat', data_item._id)
                this.selectedRange = data_item;
            }

        }
        catch(e){

        }

        
    },
    getOneArea(){
        if(this.fid != ''){
            axios({
                url : this.baseURL + 'area/' + this.fid,
                headers : {
                    authorization : store.state.token
                },
                method : "GET"
            })
            .then(res => {
                if(res.data.status)
                {

                    this.area = {
                        fid     : res.data.data.fid,
                        circle  : res.data.data.circle,
                        division : res.data.data.division,
                        range   : res.data.data.range,
                        block   : res.data.data.block,
                        beat    : res.data.data.beat,                        
                    }
                    if(res.data.data.polygon != undefined){
                        this.polygon.latlngs = null;
                        this.bounds = null;
                        var poly = [];
                        for(var i = 0; i < res.data.data.polygon.coordinates[0].length; i++){
                            var temp = latLng(res.data.data.polygon.coordinates[0][i][1], res.data.data.polygon.coordinates[0][i][0])
                            poly.push(temp);
                        }
                        this.geojson = res.data.data.polygon;
                        this.$nextTick().then(() => {
                            var group = new featureGroup();
                            this.$refs.mapControl.mapObject.eachLayer(function(layer) {
                                if (layer.feature != undefined)
                                    group.addLayer(layer);
                            });
                            

                            this.$refs.mapControl.mapObject.fitBounds(group.getBounds(), { padding: [20, 20] });
                        });
                        
                    }
                    else
                    {
                        this.polygon.latlngs = null;
                        this.bounds = null;
                    }
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'warn',
                        title: 'Important message',
                        text: 'Could not load ' + type + '.\n' + res.data.message
                    });
                }
                this.loading = false;
            })
            .catch(err => {

                this.loading = false;

                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Something went wrong!\nCouldn\'t fetch ' + type
                });
                console.log(err);
            });
        }

    },
    today(){
        var date = new Date;;
        date = date.toISOString();
        return date.substring(0,10);
    },
    printLoss(){
        console.log(this.loss);
    },
    deleteRecord(){
        if(confirm('Are you sure? Do you want to delete the record?')){
            axios({
                url : this.baseURL + "conflict/delete",
                headers : {
                    authorization : store.state.token
                },
                method : "POST",
                data : {
                    id  : this.id
                }
            })
            .then(res => {
                if(res.data.status)
                {
                    this.$notify({
                        group: 'notification',
                        type : 'success',
                        title: 'Important message',
                        text: 'Successfully deleted. Please wait you are being redirected'
                    });   
                    this.$router.push({ path: `/alerts` });
                    
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'warn',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Something went wrong!\nCouldn\'t fetch data'
                });
                console.log(err);
                this.conflictError = 'Something went wrong!\nCouldn\'t delete record';
            });
        }
    },
    
    fileInput(){
        this.approveFields.image = this.$refs.image.state[0];
    },
    fileInputUpdate(){
        this.observation.image = this.$refs.imageUpdate.state[0];
    },
    removeLayer(){

    },
    getArea(type, id){
        this.loading = true;
        var url = this.baseURL + "area/";
        if(type == 'division'){
            url += "divisions";
        }
        else{
            url += id;
        }

        axios({
            url : url,
            headers : {
                authorization : store.state.token
            },
            method : "GET"
        })
        .then(res => {
            if(res.data.status)
            {
                // if(type == 'states'){
                //     this.ranges = [];
                //     this.divisions = [];
                //     this.states = res.data.data;  
                // }   
                // else 
                if(type == 'division'){
                    this.ranges = [];
                    this.divisions = res.data.data;   
                    //Code to display selected state information              
                }   
                else if(type == 'range'){
                    this.ranges = res.data.data.hierarchyBottom;   
                    //Code to display selected division information            
                }    
                else if(type == 'beat'){
                    // this.ranges = res.data.data.hierarchyBottom;   
                    //Code to display selected range information            
                }  

                if(res.data.data.polygon != undefined){
                    this.polygon.latlngs = null;
                    this.bounds = null;
                    var poly = [];
                    for(var i = 0; i < res.data.data.polygon.coordinates[0].length; i++){
                        var temp = latLng(res.data.data.polygon.coordinates[0][i][1], res.data.data.polygon.coordinates[0][i][0])
                        poly.push(temp);
                    }
                    this.geojson = res.data.data.polygon;
                    // this.polygon.latlngs = poly;
                    // this.bounds = res.data.data.polygon;
                    this.$nextTick().then(() => {
                        var group = new featureGroup();
                        this.$refs.mapControl.mapObject.eachLayer(function(layer) {
                            if (layer.feature != undefined)
                                group.addLayer(layer);
                        });
                        

                        this.$refs.mapControl.mapObject.fitBounds(group.getBounds(), { padding: [20, 20] });
                    });
                    
                }
                else
                {
                    this.polygon.latlngs = null;
                    this.bounds = null;
                }
            }
            else
            {
                this.$notify({
                    group: 'notification',
                    type : 'warn',
                    title: 'Important message',
                    text: 'Could not load ' + type + '.\n' + res.data.message
                });
            }
            this.loading = false;
        })
        .catch(err => {

            this.loading = false;

            this.$notify({
                group: 'notification',
                type : 'error',
                title: 'Important message',
                text: 'Something went wrong!\nCouldn\'t fetch ' + type
            });
            console.log(err);
        });
    },
    
    submitArea(){

        try{
            var error = false, errorText = "";

            if(this.addArea.name == null){
                error = true;
                errorText += "Area name cannot be empty.\n"
            }

            if(this.addArea.type == null){
                error = true;
                errorText += "Area type cannot be empty.\n"
            }

            if(this.addArea.polygon == null){
                // error = true;
                // errorText += "Area polygon cannot be empty.\n"
            }
            else{
                this.addArea.polygon = JSON.parse(this.addArea.polygon);
            }

            if(error){
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Empty Fields!',
                    text: errorText
                });
            }
            else
            {
                this.$notify({
                    group: 'notification',
                    type : 'info',
                    title: 'Submitting data..',
                    text: 'Please wait while we are uploading data!'
                });
                axios({
                    url : this.baseURL + "area/",
                    headers : {
                        authorization : store.state.token
                    },
                    data : this.addArea,
                    method : "POST"
                })
                .then(res => {
                    if(res.data.status)
                    {
                        this.$notify({
                            group: 'notification',
                            type : 'success',
                            title: 'Important message',
                            text: 'Area created succesfully'
                        });
                        this.getArea('division', null);
                        this.selectedState = null;
                        this.selectedDivision = null;
                        this.selectedRange = null;
                        this.showStateModal(false);
                        this.showDivisionModal(false);
                        this.showRangeModal(false);
                        
                    }
                    else
                    {
                        this.$notify({
                            group: 'notification',
                            type : 'warn',
                            title: 'Important message',
                            text: 'Could create new area!\n' + res.data.message
                        });
                    }
                })
                .catch(err => {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: 'Something went wrong!\n' + err
                    });
                    console.log(err);
                });

            }
        }
        catch(e){
            this.$notify({
                group: 'notification',
                type : 'error',
                title: 'Important message',
                text: 'Something went wrong!\n' + e
            });
            console.log(e);
        }
    }
  }
}
</script>
<style scoped>
    .pad-r-0 {
        padding-right: 0px !important;
    }
    .pad-l-0 {
        padding-left: 0px !important;
    }
    .hidden_header {
        display: none;
    }
</style>
